export default __webpack_public_path__ + "static/media/nine.64922678.jpeg";